import './Footer.css';

const COMPLAINTS_EMAIL = 'complains@hotmate.ai';
const TERMS_PDF = 'https://cdn.hotmate.ai/docs/Hotmate - Terms of Services - 01-09-2025.pdf';
const NOTICE_2257_PDF = 'https://cdn.hotmate.ai/docs/Hotmate - 18 U.S.C. 2257 Exemption - 01-04-2025.pdf';

export function Footer({ onNavigate }) {
    return (
        <footer className="mnFooter">
            <div className="mnFooterInner">
                <div className="mnFooterBrand">
                    <span className="mnFooterLogo">Make<span className="mnFooterLogoAccent">porn</span></span>
                    <span className="mnFooterTag">AI photo &amp; video generator · 2026</span>
                </div>
                <div className="mnFooterLinks">
                    <button className="mnFooterLink" onClick={() => onNavigate('landing')}>About</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('terms')}>Terms</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('privacy')}>Privacy</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('payment')}>Payment rules</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('compliance')}>2257</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('contact')}>Contact</button>
                    <button className="mnFooterLink" onClick={() => onNavigate('report')}>Report content</button>
                    <a className="mnFooterLink" href={TERMS_PDF} target="_blank" rel="noopener noreferrer">Terms of Service (PDF)</a>
                    <a className="mnFooterLink" href={NOTICE_2257_PDF} target="_blank" rel="noopener noreferrer">2257 Exemption (PDF)</a>
                </div>
            </div>
            <div className="mnFooterLegal">
                <p className="mnFooterLegalLine">
                    This website is operated by Hotmate Ltd, Giannou Kranidioti &amp; Pargas, 9, office 102, Nicosia, 1065, Cyprus.
                </p>
                <p className="mnFooterLegalLine">
                    If you have any complaints or concerns, you may contact us at{' '}
                    <a className="mnFooterLegalLink" href={`mailto:${COMPLAINTS_EMAIL}`}>{COMPLAINTS_EMAIL}</a>.
                    Any submission will receive a response and be resolved within a reasonable timeframe, typically within 7 business days.
                </p>
            </div>
        </footer>
    );
}
